import { PostTypeEnum } from "../../enums/post.enum";

interface FeedParams {
  limit: number;
  offset: number;
  postType?: PostTypeEnum;
}

export const formatFeedParams = ({ limit, offset, postType }: FeedParams): string => {
  const params = new URLSearchParams();
  params.append("limit", limit.toString());
  params.append("offset", offset.toString());

  if (postType) {
    params.append("type", postType);
    if (postType === PostTypeEnum.SERVICE || postType === PostTypeEnum.PROGRAM)
      params.append("includeGoServicePosts", "true");
  }

  return params.toString();
};
